// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner-ad[data-v-5b5bf28e]{margin-top:.5rem}.banner-ad img[data-v-5b5bf28e]{border-radius:.12rem;width:7rem}", ""]);
// Exports
module.exports = exports;
